<app-block-wrapper [_editable]="_editable" [style]="style">
  <div class="example-galleries" *ngIf="items.length">
    <a
      *ngFor="let gallery of items"
      [href]="gallery.link"
      class="example-gallery"
      target="_blank"
      animateInView="up"
      [class.show-hover]="!!gallery.link"
      [appStoryblok]="gallery._editable"
    >
      <div class="header">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <app-picture
        *ngIf="gallery.screenshot?.filename"
        [url]="gallery.screenshot?.filename | storyblokCdn"
        [maxWidth]="maxWidth"
        [width]="1160"
        [height]="708"
        [scale]="0.5"
        [loading]="'eager'"
      >
      </app-picture>
      <div class="empty" *ngIf="!gallery.screenshot?.filename"></div>
    </a>
  </div>
  <div class="empty" *ngIf="items && !items.length">EMPTY SHOWCASE LIST</div>
</app-block-wrapper>
